(() => {
  // Prevent duplicate listeners when Shopify reloads this section.
  if (window.articleTocInitialized) return;
  window.articleTocInitialized = true;

  const mobileQuery = window.matchMedia('(max-width: 989px)');

  function initializeArticleTocs(scope = document) {
    const tocs = [...scope.querySelectorAll('[data-article-toc]')];

    if (scope instanceof Element && scope.matches('[data-article-toc]')) {
      tocs.unshift(scope);
    }

    tocs.forEach((toc) => {
      const content = document.getElementById(toc.dataset.contentId);
      const list = toc.querySelector('.article-toc__list');
      const toggle = toc.querySelector('.article-toc__toggle');

      toc.hidden = true;

      if (!content || !list) return;

      list.replaceChildren();

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');

        // Assignment avoids duplicate handlers on reinitialization.
        toggle.onclick = () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
        };
      }

      const headings = [...content.querySelectorAll('h2')]
        .filter((heading) => heading.textContent.trim());

      if (headings.length < 2) return;

      const reservedIds = new Set(
        [...document.querySelectorAll('[id]')]
          .map((element) => element.id)
      );

      const handledIds = new Set();

      headings.forEach((heading, index) => {
        const label = heading.textContent.trim();
        let id = heading.id;

        if (
          !id ||
          handledIds.has(id) ||
          document.getElementById(id) !== heading
        ) {
          const slug = label
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
            .replace(/^-+|-+$/g, '') || 'section-' + (index + 1);

          const base = content.id + '-' + slug;
          id = base;

          let suffix = 2;

          while (reservedIds.has(id)) {
            id = base + '-' + suffix++;
          }

          heading.id = id;
          reservedIds.add(id);
        }

        handledIds.add(id);

        const headingTag = heading.tagName.toLowerCase();

        const item = document.createElement('li');
        item.className =
          'article-toc__item article-toc__item--' + headingTag;

        const itemHeading = document.createElement(headingTag);
        itemHeading.className = 'article-toc__item-heading';

        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(id);
        link.textContent = label;

        link.addEventListener('click', (event) => {
          // Preserve modified clicks and normal desktop behavior.
          if (
            !toggle ||
            !mobileQuery.matches ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          toggle.setAttribute('aria-expanded', 'false');

          // Move keyboard focus out of the collapsed list.
          if (!heading.hasAttribute('tabindex')) {
            heading.setAttribute('tabindex', '-1');

            heading.addEventListener('blur', () => {
              heading.removeAttribute('tabindex');
            }, { once: true });
          }

          heading.focus({ preventScroll: true });

          // The link's native action handles the hash and scrolling
          // after the list collapses.
        });

        itemHeading.appendChild(link);
        item.appendChild(itemHeading);
        list.appendChild(item);
      });

      toc.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeArticleTocs(),
      { once: true }
    );
  } else {
    initializeArticleTocs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeArticleTocs(event.target);
  });
})();